const presenteInitialState = {
    presente: {
      data: null,
      loading: false,
      error: false,
    },
  };
  
  export default presenteInitialState;